export const VISIT_STP = 'stp';
export const VISIT_VISION = 'vision';
export const VISIT_VALET = 'valet';

export type VisitType = typeof VISIT_STP | typeof VISIT_VISION | typeof VISIT_VALET;
